import { camelizeKeys } from 'humps'
import {
  USER_TYPE,
  userTypes,
  IUserTypes,
  ISingleUserType,
  IKeyedUserTypes,
  IUserGroupBooleans,
} from 'constants/userTypes'

export const keyedUserTypes: IKeyedUserTypes = Object.keys(userTypes).reduce((types, typeGroup) => {
  const typeGroupCasted = typeGroup as keyof IUserTypes
  userTypes[typeGroupCasted].forEach((type: ISingleUserType) => {
    types[type.value] = type
  })
  return camelizeKeys(types) as IKeyedUserTypes
}, {} as IKeyedUserTypes)

export const userTypeBooleans = (userType?: keyof IUserTypes) => {
  if (!userType) return {}
  return Object.keys(keyedUserTypes).reduce((bools, type) => {
    const key = `is${type.charAt(0).toUpperCase()}${type.slice(
      1,
      type.length
    )}` as keyof IUserGroupBooleans
    const typeCasted = type as keyof IKeyedUserTypes
    bools[key] = userType === keyedUserTypes[typeCasted].value
    return bools
  }, {} as IUserGroupBooleans)
}

export const userGroupBooleans = (userType: keyof IUserTypes) => {
  const groups = userTypeBooleans(userType) as IUserGroupBooleans
  const { isAdmin, isDispatcher, isDriver, isOwnerOperator, isSalesRep, isShipper } = groups
  return {
    isAdmin,
    isCarrier: isDriver || isOwnerOperator || isDispatcher,
    isShipper: isShipper || isSalesRep,
  }
}

export const isUserType = (type: keyof typeof USER_TYPE, comparedValue: string): boolean => {
  const userType = userTypes[type]

  return userType.some(({ value }) => comparedValue === value)
}
